<template>
    <v-container>
      <template v-if="maintain">
        <div class="d-flex justify-center align-center">
          <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
        </div>
      </template>
      <template v-else>
        <template v-if="CheckAdmin">
            <v-card
                    class="mx-auto"
                    style="border: darkgreen 2px solid;background-color: linen"
            >
                <v-card-title>
                    <v-icon
                            large
                            left
                    >
                        mdi-file-edit
                    </v-icon>
                    <span>ยื่นการข้อมูลหลักสูตร</span>
                </v-card-title>

                <v-card-text class="headline font-weight-bold">
                </v-card-text>

                <v-card-actions class="justify-space-around">
                    <v-row
                            class="justify-space-around"
                    >
                        <v-col align="center" col="12" md="8">
                            <v-btn
                                    text
                                    v-for="menu in Menu"
                                    :key="menu.id"
                                    @click="goToPage(menu.page)">
                                <span>{{menu.value}}</span>
                            </v-btn>
                            <hr/>
                        </v-col>
                    </v-row>
                </v-card-actions>

                <router-view></router-view>

            </v-card>
        </template>
        <template v-else>

        </template>
      </template>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Const from "@/const/Const";

    export default {
        name: "ManageCourse",
        data() {
            return {
              pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
              maintain: false,
                CheckAdmin: false,
                Course_code: '',
                Course_name: '',
                Course_des: '',
                Course_status: '1',
                Course_group: '',
                Course_hour: '',
                Booster: '',
                General_credit: '',
                Period_code: '',
                Course_type: '',
                Course: {
                    Course_code: '',
                    Course_name: '',
                    Course_des: '',
                    Course_status: '1',
                    Course_group: '',
                    Course_hour: '',
                    Booster: '',
                    General_credit: '',
                    Period_code: '',
                    Course_type: '',
                },
                rules: {
                    required: value => !!value || 'Required.',
                    counterCourse: value => value.length <= 8 || 'Max 8 characters',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    },
                },
                Menu: [
                    {
                        'id': 1,
                        'value': 'ข้อมูลหลักสูตร',
                        page: '/ManageCourse/DataCourse'
                    },
                    {
                        'id': 2,
                        'value': 'เพิ่มข้อมูลหลักสูตร',
                        page: '/ManageCourse/InsertCourse'
                    }
                    ,
                    {
                        'id': 3,
                        'value': 'แก้ไขข้อมูลหลักสูตร',
                        page: '/ManageCourse/UpdateCourse'
                    }
                ]
            }
        },
        computed: {
            ...mapGetters({
                MeData: 'Staff/getMeData',
                AllPermission: 'Permission/getAllPermission',
              AllDepPermission: 'Permission/getAllDepUserPermission',
              DepPermission: 'Permission/getDepUserPermission',
              PermissionAdmin: 'Permission/getPermission',
              Permission: 'Permission/getPermissionUser',
              Permission_Ms: 'Permission/getPermissionMs',
              Permission_Dep_User: 'Permission/getPermissionDepUser',
              Permission_Dep: 'Permission/getPermissionDep',
              Approve_Ms: 'Permission/getApproveMs',
              Approve: 'Permission/getApprove',
              MenuPermiss: 'Permission/getMenuPermiss',
              IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
              appColor: 'Page/getColor',
              appHeaderName: 'Page/getHeaderName',
            })
        },
        methods: {
            ...mapActions({
                initMeData: 'Staff/initMeData',
              initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
              initPermissionDepUserData: 'Permission/initPermissionDepUserData',
              initPermissionUserData: 'Permission/initPermissionUserData',
              initPermissionMsData: 'Permission/initPermissionMsData',
              getPermissionUserData: 'Permission/getPermissionUserData',
              getPermissionDep: 'Permission/getPermissionDepData',
              initPermissionDepData: 'Permission/initPermissionDepData',
              getPermissionDepUserData: 'Permission/getPermissionDepUserData',
              initApproveMsData: 'Permission/initApproveMsData',
              initApproveData: 'Permission/initApproveData',
              getPermissionData: 'Permission/getPermissionData',
              initPermissionData: 'Permission/initPermissionData',
              getMenuPermissData: 'Permission/getMenuPermissData',
              getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
              changeColor: 'Page/changeColor',
              changeHeaderName: 'Page/changeHeaderName',
              changeTypeProject: 'Project/changeTypeProject',
            }),
            goToPage: function (page) {
                this.$router.push(page)
            }
        },
        mounted() {
          this.changeColor({
            color: Const.defaultColorApp
          })
          this.changeHeaderName({
            headerName: Const.defaultHeaderApp
          })
          this.changeTypeProject({
            type: null
          })
            this.initMeData().then(async res => {
              if (res) {
                await this.getIgnoreMenuPermissData({
                  perid: this.MeData[0].perid,
                  page_id: '14'
                })

                this.getMenuPermissData().then(res => {
                  if (res) {
                    if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '14' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.getPermissionData({
                        perid: this.MeData[0].perid
                      }).then(res => {
                        if (res) {
                          this.PermissionAdmin.map((Per_i, idx) => {
                            if (Per_i.permission_id == '2000') {
                              this.CheckAdmin = true
                            } else {
                              if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                                this.$router.push('/')
                              }
                            }
                          })
                        } else {
                          // this.$router.push('/')
                          this.getPermissionUserData({
                            perid: this.MeData[0].perid
                          }).then(res => {
                            if (res) {
                              this.Permission.map((Per_i, idx) => {
                                if (Per_i.permission_id == '2000') {
                                  this.CheckAdmin = true
                                } else {
                                  if (!this.CheckAdmin && idx == this.Permission.length - 1) {
                                    this.$router.push('/')
                                  }
                                }
                              })
                            } else {
                              this.$router.push('/')
                            }
                          })
                        }
                      })
                    } else {
                      this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '14' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '14')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '14' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '14')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                  }
                })
              }
            })
        }
    }
</script>

<style scoped>
    * {
    }
</style>
